import * as _ from 'lodash';
import Model from './Model';
import Provider from './Provider';
import User from './User';
import ArrayList from './ArrayList';
import { knob } from './Configuration';
import * as moment from 'moment';
import { applyMixins } from './Mixin/Mixin';
import Deliverable from './Mixin/Deliverable';
import ProductBase from './Base/ProductBase';

class Product extends ProductBase {}

class Collection extends Model {
  user: any;
  name: String;
  id: Number;
  constructor(options) {
    super();
    (this as any).products = d => {
      return new ArrayList<Product>(
        Product,
        d.data.map(s => {
          s[knob.circular] = ['collection'];
          return s;
        })
      );
    };
    (this as any).user = d => {
      return new User(d.data);
    };
    (this as any).provider = d => {
      return new Provider(d.data);
    };
    this.bind(options);
  }
  getTitle() {
    return this.name;
  }
  getPathIdentifier() {
    return this.id;
  }
  getLastConsignmentSent(): moment.Moment {
    let m = moment(this['last_consignment_sent_date']);
    return m;
  }
  getPickupConfirmationSent(): moment.Moment {
    let m = moment(this['pickup_confirmation_sent_date']);
    return m;
  }
  getProductPricingEnd(): moment.Moment {
    let m = moment(this['product_pricing_end_date']);
    return m;
  }
  getArrival(): moment.Moment {
    let m = moment(this['arrival_date']);
    return m;
  }
  getProductShootingStart(): moment.Moment {
    let m = moment(this['product_shooting_start_date']);
    return m;
  }
  getProductShootingEnd(): moment.Moment {
    let m = moment(this['product_shooting_end_date']);
    return m;
  }
  getPickup(): moment.Moment {
    let m = moment(this['pickup_date']);
    return m;
  }
}
applyMixins(Collection, [Deliverable]);
export default Collection;
